/* eslint-disable */
/**
 * Generate by @yy/tagee-cli v0.2.4
 * Tagee Project ID: 160
 * Tagee Project Branch: feature-20220712-tag
 * Tagee API link: http://tagee.yy.com/#/project/160/feature-20220712-tag
 */
/* tslint:disable */
import Fetcher from '@yy/fetcher'
import GuildserviceAppRequests from './GuildserverApp/requests'

const fetcher = new Fetcher({ paths: {}, axiosConfig: { withCredentials: true } })

const fetchers = {
  ...GuildserviceAppRequests(fetcher)
}

export default fetchers
